import React from 'react';
import FloatingChatButton from './FloatingChatButton';
import SupportChatWindow from './SupportChatWindow';
import ChatTeaserBubble from './ChatTeaserBubble';

const FloatingSupportChat: React.FC = () => {
  return (
    <>
      <ChatTeaserBubble />
      <FloatingChatButton />
      <SupportChatWindow />
    </>
  );
};

export default FloatingSupportChat;